import { lazy } from 'react';

const LoginRoutes = [
    {
        label: 'test-login',
        key: 'test-login',
        path: 'test-login',
        element: lazy(() => import('@/page/Login/AuthLogin/TestLogin'))
    },
    {
        label: 'test-login',
        key: 'test-login',
        path: 'public/test-login',
        element: lazy(() => import('@/page/Login/AuthLogin/TestLogin'))
    },
    //通用AuthTokenLogin
    {
        label: 'AuthTokenLogin',
        key: 'AuthTokenLogin',
        path: 'auth-token-login',
        element: lazy(() => import('@/page/Login/AuthLogin/AuthTokenLogin')),
        show: true
    },
    //通用AuthCodeLogin
    {
        label: 'AuthCodeLogin',
        key: 'AuthCodeLogin',
        path: 'auth-code-login',
        element: lazy(() => import('@/page/Login/AuthLogin/AuthCodeLogin')),
        show: true
    },
    //新吴oauth
    {
        label: 'OauthLogin',
        key: 'OauthLogin',
        path: 'oauth-login',
        element: lazy(() => import('@/page/Login/OauthLogin')),
        show: true
    },
    //博海云著
    {
        label: 'BhyzLogin',
        key: 'BhyzLogin',
        path: 'bhyz-login',
        element: lazy(() => import('@/page/Login/Bhyz')),
        show: true
    },
    {
        label: 'NbzjLogin',
        key: 'NbzjLogin',
        path: 'nbzj-login',
        element: lazy(() => import('@/page/Login/Nbzj')),
        show: true
    },
    // 企业微信绑定，自动登录
    {
        label: 'WxWorkBind',
        key: 'WxWorkBind',
        path: 'wxWork-bind',
        element: lazy(() => import('@/page/Login/WxWorkBind')),
        show: true
    }
];

export default LoginRoutes;
